// extracted by mini-css-extract-plugin
module.exports = {"clsgx9t":"clsgx9t","cx7xgfj":"cx7xgfj","s2r3fut":"s2r3fut","sa1y67m":"sa1y67m","time":"time","dot":"dot","category":"category","divide":"divide","t1r500ik":"t1r500ik"};